import FilterTypes from "~/constants/FilterTypes"

export const resetFilter = () => {
  Object.values(FilterTypes)?.forEach(link => localStorage.removeItem(link))
}
